import { createFileRoute } from "@tanstack/react-router";
import SystemMessagesPage from "@/pages/SystemMessagesPage";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/system-messages"
)({
  component: SystemMessagesPage,
});
